// submitUploadAsset.js
'use strict';
import throttle from 'lodash/throttle';

import { MERGE_ASSET_DATA } from '../ActionTypes.js';

import pushToastr from '../action/pushToastr.js';

import getAssetData from '../selector/getAssetData';

import uploadFile from '../resource/uploadFile.js';
import uploadJobReferences from '../resource/uploadJobReferences.js';
import { Status as UploadStatus } from '../resource/uploadConstants.js';

/**
 * Submit upload asset
 * @kind action
 * @param {string} {assetId} - asset id.
 * @return {Promise} Action promise.
 */
const submitUploadAsset =
  ({ assetId }) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: MERGE_ASSET_DATA,
        payload: {
          selectPath: [assetId],
          data: {
            status: UploadStatus.UPLOAD_STARTED,
          },
        },
      });
      const xhr = new XMLHttpRequest();
      uploadJobReferences.set(`${assetId}:media:xhr`, xhr);
      const file = uploadJobReferences.get(`${assetId}:media:file`);
      if (!file) {
        throw new Error('File not found.');
      }
      const contentMd5 = getAssetData(getState(), [assetId], 'contentMd5');
      if (!contentMd5) {
        throw new Error('Incorrect file md5.');
      }
      const uploadUrl = getAssetData(getState(), [assetId], 'uploadUrl');
      if (!uploadUrl) {
        throw new Error('Incorrect upload url.');
      }
      const upload = () =>
        new Promise((resolve, reject) => {
          uploadFile({
            url: uploadUrl,
            xhr,
            file,
            fileMd5: contentMd5,
            onError: () => reject(new Error('Error at upload')),
            onAbort: () => reject(new Error('Abort at upload')),
            onLoad: () => resolve(),
            onUploadProgress: throttle(({ total, loaded }) => {
              const diff = file.size - total;
              const progress = Math.floor(((loaded + diff) / file.size) * 100);
              dispatch({
                type: MERGE_ASSET_DATA,
                payload: {
                  selectPath: [assetId],
                  data: {
                    // keep 99%, will change to 100% when receive response 200.
                    progress: Math.min(progress, 99),
                  },
                },
              });
            }, 100),
            onRetry: () => {
              dispatch(
                pushToastr({
                  textKey: 'retry_upload_video',
                })
              );
            },
          });
        });
      await upload();
      return dispatch({
        type: MERGE_ASSET_DATA,
        payload: {
          selectPath: [assetId],
          data: {
            // keep 99%, will change to 100% when receive response 200.
            progress: 100,
          },
        },
      });
    } catch (error) {
      return dispatch({
        type: MERGE_ASSET_DATA,
        payload: {
          selectPath: [assetId],
          data: {
            status: UploadStatus.UPLOAD_FAILED,
            reasons: [error.message],
          },
        },
      });
    }
  };

export default submitUploadAsset;
